import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { peopleInsider } from '@/mocks/home';

type Person = (typeof peopleInsider)[number];

function PersonCard({ person }: { person: Person }) {
  const [followed, setFollowed] = useState(false);

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
      <div className="relative h-[340px] w-full overflow-hidden md:h-[400px]">
        <img
          src={person.image}
          alt={`${person.name} 人物内幕配图`}
          title="人物内幕 今日黑料"
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-5">
          <span className="font-label text-[11px] tracking-editorial text-accent-300">
            {person.role}
          </span>
          <h3 className="mt-1 font-heading text-xl font-bold text-background-50">
            {person.name}
          </h3>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-5">
        <p className="font-body text-sm leading-relaxed text-foreground-600">
          {person.teaser}
        </p>
        <div className="mt-5 flex items-center justify-between border-t border-background-200/80 pt-4">
          <span className="font-label text-xs text-foreground-500">{person.followers}</span>
          <button
            type="button"
            onClick={() => setFollowed((v) => !v)}
            className={`flex items-center gap-1.5 rounded-full border px-4 py-1.5 font-label text-xs transition-colors ${
              followed
                ? 'border-primary-300 bg-primary-50 text-primary-700'
                : 'border-foreground-900 bg-foreground-950 text-background-50 hover:bg-foreground-800'
            }`}
          >
            <i className={followed ? 'ri-check-line' : 'ri-add-line'} />
            {followed ? '已关注' : '关注'}
          </button>
        </div>
      </div>
    </article>
  );
}

export default function PeopleInsider() {
  return (
    <section id="people" className="w-full bg-background-100/60 px-5 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-[1320px]">
        <SectionHeading
          index="03"
          eyebrow="人物内幕"
          title="风波里被反复提到的三张面孔"
          description="姓名与身份均做过模糊处理，只保留事件中被讨论的位置关系。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 md:mt-14 md:gap-10 lg:grid-cols-3">
          {peopleInsider.map((person) => (
            <PersonCard key={person.id} person={person} />
          ))}
        </div>
      </div>
    </section>
  );
}